import IMG from "../../constants/image";
import Input from "../Common/Input";
import Button from "../Common/Button";
import React, {useState} from "react";
import {VARIANT} from "../../constants";
import './style.css';
import {validatePhone} from "../../utils";
import {merchantRegister} from "../../network/api";
import authStore from '../../store/authStore';
import {ENV} from "../../network/config";

const StepPhone = ({setStep}) => {

    const {setConfirmId, setPhoneNumber} = authStore();
    const [phone, setPhone] = useState('');
    const [error, setError] = useState('');


    const onChange = (e) => {
        e.preventDefault();
        setPhone(e.target.value);
    }

    const handleSubmit = () => {
        if (!validatePhone(phone)) {
            setError('Số điện thoại không hợp lệ');
        } else {
            handleMerchantRegister({phoneNumber: phone});
        }
    }

    const handleMerchantRegister = async ({phoneNumber}) => {
        const res = await merchantRegister({phoneNumber})
        const data = res?.data || {}
        if (res?.success) {
            setPhoneNumber(phoneNumber)
            if (data?.data?.confirmId) {
                setConfirmId(data?.data?.confirmId)
                setStep(1)
            } else if (data?.code === "RD-01") {
                setStep(3)
            }
        } else setError("Số điện thoại không hợp lệ");
    }


    return (
        <div className='w-[320px] md:w-[400px] py-[15px] px-[20px] md:px-[50px] md:py-12 text-xs bg-white rounded-2xl'>
            <form className='flex flex-col justify-center items-center text-center gap-5' action="">
                <h2 className='text-xl font-bold'>Xin chào,</h2>
                <p className='text-sm'>Đăng nhập hoặc Đăng ký tài khoản mới</p>
                <div className='w-full'>
                    <Input
                        type='number'
                        className='w-full h-[44px]'
                        inputMode="numeric"
                        pattern="[0-9]*"
                        icon={IMG.icon.phoneIpBlack}
                        placeholder='Nhập số điện thoại'
                        value={phone}
                        error={error}
                        onChange={onChange}
                        setError={setError}
                    />
                </div>
                <div className='w-full'>
                    <Button type='submit' variant={VARIANT.PRIMARY} className='w-full h-[44px]' onClick={handleSubmit}>Tiếp
                        tục</Button>
                </div>
                <p className=''>
                    Nhấn “Tiếp tục” đồng nghĩa với việc bạn xác nhận rằng mình đã đọc và đồng ý với <a className='link'
                                                                                                       href={`${ENV.FUNONG_DOMAIN}/dieu-khoan-su-dung`}
                                                                                                       target='_blank'>Điều
                    khoản</a> & <a className='link' href={`${ENV.FUNONG_DOMAIN}/chinh-sach-bao-mat`} target='_blank'>Chính
                    sách</a> người
                    dùng của FUTA FuNong
                </p>
            </form>
        </div>
    );
}

export default StepPhone;
